export const AUTH_SESSION_CHANNEL = 'auth-session-sync';

export const AUTH_SESSION_PURGED_EVENT = 'SESSION_PURGED' as const;

export type AuthSessionBroadcastMessage = {
  type: typeof AUTH_SESSION_PURGED_EVENT;
  /** Prevents the originating tab from handling its own broadcast. */
  originTabId: string;
};

const TAB_ID =
  typeof window !== 'undefined'
    ? `${Date.now()}-${Math.random().toString(36).slice(2)}`
    : 'server';

let authSessionChannel: BroadcastChannel | null = null;

const getAuthSessionChannel = (): BroadcastChannel | null => {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') {
    return null;
  }

  if (!authSessionChannel) {
    authSessionChannel = new BroadcastChannel(AUTH_SESSION_CHANNEL);
  }

  return authSessionChannel;
};

export const broadcastSessionPurged = (): void => {
  const channel = getAuthSessionChannel();

  if (!channel) {
    return;
  }

  const message: AuthSessionBroadcastMessage = {
    type: AUTH_SESSION_PURGED_EVENT,
    originTabId: TAB_ID,
  };

  channel.postMessage(message);
};

export const subscribeToAuthSessionBroadcast = (
  onSessionPurged: () => void,
): (() => void) => {
  const channel = getAuthSessionChannel();

  if (!channel) {
    return () => undefined;
  }

  const handleMessage = (event: MessageEvent<AuthSessionBroadcastMessage>) => {
    if (event.data?.type !== AUTH_SESSION_PURGED_EVENT) {
      return;
    }

    if (event.data.originTabId === TAB_ID) {
      return;
    }

    onSessionPurged();
  };

  channel.addEventListener('message', handleMessage);

  return () => {
    channel.removeEventListener('message', handleMessage);
  };
};

export const closeAuthSessionBroadcast = (): void => {
  authSessionChannel?.close();
  authSessionChannel = null;
};
